import Weather from './pages/Weather/Weather'

function App() {
  return (
    <div>
        <Weather/>
    </div>
  );
}

export default App;
